/**
 * @generated SignedSource<<8754453bffd0c91af99fbfa5f27598c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type PaymentMethodTypeV2 = "ACH_BANK_ACCOUNT" | "APPLE_PAY" | "ARGENTINE_BANK_ACCOUNT" | "BANCOMAT_PAY" | "BLIK" | "CAD_WIRE" | "DENEB_IMPS" | "DENEB_UPI" | "DIRECT_DEPOSIT_ACCOUNT" | "EFT" | "FEDWIRE" | "FIAT_ACCOUNT" | "GIFTCARD" | "GOOGLE_PAY" | "IDEAL_BANK_ACCOUNT" | "INDIA_BANK_ACCOUNT" | "INDIA_UPI" | "INTERAC" | "MB_WAY" | "OPEN_BANKING" | "PAYMENT_METHOD_TYPE_UNKNOWN" | "PAYPAL_ACCOUNT" | "PIX" | "PIX_DEPOSIT" | "PIX_WITHDRAWAL" | "QD" | "REMITLY" | "RTP" | "SAMSUNG_PAY" | "SEPA_BANK_ACCOUNT" | "SEPA_V2" | "SG_FAST" | "SG_PAYNOW" | "SIC" | "SOFORT" | "SWIFT_BANK_ACCOUNT" | "TRUSTLY" | "UK" | "UK_BANK_ACCOUNT" | "WORLDPAY_CARD" | "ZENGIN_DEPOSIT" | "ZENGIN_DEPOSIT_V2" | "ZENGIN_WITHDRAWAL" | "ZENGIN_WITHDRAWAL_V2" | "ZEPTO" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type readFiatWalletPaymentMethodFragment$data = {
  readonly currency: string;
  readonly limits: {
    readonly remainingAvailableLimit: {
      readonly currency: string;
      readonly value: string;
    };
  } | null;
  readonly name: string;
  readonly pickerData: {
    readonly __typename: "CoinbaseFiatAccountPickerData";
    readonly fiatAccount: {
      readonly uuid: string;
    };
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly type: PaymentMethodTypeV2;
  readonly uuid: string;
  readonly " $fragmentType": "readFiatWalletPaymentMethodFragment";
};
export type readFiatWalletPaymentMethodFragment$key = {
  readonly " $data"?: readFiatWalletPaymentMethodFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"readFiatWalletPaymentMethodFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "readFiatWalletPaymentMethodFragment"
};

(node as any).hash = "6e2628c62a17655e65bca09386d2f081";

export default node;
